// Traduções do Painel de Jornada — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'jornada.dashboard.title': 'Painel de Jornada',
    'jornada.dashboard.eyebrow': 'Operação',
    'jornada.dashboard.loadError': 'Não foi possível carregar a jornada.',
    'jornada.dashboard.retry': 'Tentar de novo',
    'jornada.dashboard.kpiEmJornada': 'Em jornada',
    'jornada.dashboard.kpiEmJornadaHint': 'do total da frota',
    'jornada.dashboard.kpiDirigindo': 'Dirigindo',
    'jornada.dashboard.kpiDescanso': 'Em descanso',
    'jornada.dashboard.kpiRiscoDsr': 'Risco de DSR',
    'jornada.dashboard.kpiRiscoDsrHint': '6+ dias sem folga',
    'jornada.dashboard.hintNow': 'agora',
    'jornada.dashboard.somenteHoje': 'Hoje, ao vivo. Dia fechado fica no Histórico',
    'jornada.base.total_one': '{{count}} colaborador na base do dia',
    'jornada.base.total_other': '{{count}} colaboradores na base do dia',
    'jornada.base.recorte': '{{n}} de {{total}}',
    'jornada.base.comMarcacao': 'com marcação registrada hoje',
    'jornada.base.comConjunto': 'com conjunto ativo',
    'jornada.base.dica': 'A base é a mesma nos três blocos: todo motorista e operador ativo no cadastro. O que muda é o recorte de cada um.',
    'jornada.analise.indisponivel': 'Indisponível até fechar',
    'jornada.analise.encerramentoIndisponivel': 'nenhuma jornada encerrada ainda. A frota fecha em lote no dia seguinte, então não há o que medir agora',
    'jornada.top.semEncerramento': 'Nenhuma jornada encerrada ainda hoje',
    'jornada.dashboard.kpiDirecaoHoje': 'Horas de direção',
    'jornada.dashboard.kpiHoraExtra': 'Horas extras',
    'jornada.dashboard.kpiHorasHint': 'somadas hoje, frota inteira',
    'jornada.dashboard.statusTitle': 'Frota em jornada',
    'jornada.dashboard.statusCenter': 'em jornada',
    'jornada.dashboard.statusEmpty': 'Ninguém em jornada agora.',
    'jornada.dashboard.atencaoTitle': 'Atenção',
    'jornada.dashboard.dsrTitle': 'Descanso semanal',
    'jornada.dashboard.dsrDias_one': '{{count}} dia',
    'jornada.dashboard.dsrDias_other': '{{count}} dias',
    'jornada.dashboard.dsrEmpty': 'Ninguém em risco.',
    'jornada.dashboard.dispTitle': 'Ficando disponível',
    'jornada.dashboard.dispEmpty': 'Sem previsões próximas.',
    'jornada.analytics.indisponivel': 'Marcações do dia indisponíveis agora. Os gráficos voltam no próximo ciclo.',
    'jornada.timeline.title': 'Linha do tempo da frota',
    'jornada.timeline.count_one': '{{count}} motorista',
    'jornada.timeline.count_other': '{{count}} motoristas',
    'jornada.timeline.empty': 'Sem marcações hoje.',
    'jornada.timeline.periodo': '{{ini}} às {{fim}}',
    'jornada.timeline.agora': 'agora',
    'jornada.tipo.direcao': 'Direção',
    'jornada.tipo.parado': 'Parado',
    'jornada.tipo.refeicao': 'Refeição',
    'jornada.tipo.repouso': 'Repouso',
    'jornada.tipo.espera': 'Espera',
    'jornada.tipo.descanso': 'Descanso',
    'jornada.tipo.outro': 'Outro',
    'jornada.tipo.he': 'Hora extra',
    'jornada.composicao.title': 'Frota ao longo do dia',
    'jornada.composicao.hint': 'Motoristas em cada estado, minuto a minuto',
    'jornada.top.direcao': 'Quem mais dirigiu hoje',
    'jornada.top.horaExtra': 'Quem mais fez hora extra',
    'jornada.top.horaExtraDirecao': 'Mais hora extra em direção',
    'jornada.top.horaExtraParado': 'Mais hora extra parado',
    'jornada.top.parado': 'Quem mais ficou parado',
    'jornada.top.paradoAbertura': 'Maior tempo parado após abrir',
    'jornada.top.paradoEncerramento': 'Maior tempo parado antes de fechar',
    'jornada.top.empty': 'Sem dados hoje.',
    'jornada.top.infracao.interjornada': 'Menor interjornada',
    'jornada.top.infracao.refeicao': 'Refeição mais fora do intervalo',
    'jornada.top.infracao.direcao': 'Maior direção contínua',
    'jornada.top.infracao.deslocamento': 'Maior deslocamento entre abertura e fim',
    'jornada.top.semInfracao': 'Nenhuma ocorrência hoje',
    'jornada.top.periodo.direcao': 'Quem mais dirigiu no período',
    'jornada.top.periodo.horaExtra': 'Quem mais fez hora extra no período',
    'jornada.top.periodo.horaExtraDirecao': 'Mais hora extra em direção no período',
    'jornada.top.periodo.horaExtraParado': 'Mais hora extra parado no período',
    'jornada.top.periodo.parado': 'Quem mais ficou parado no período',
    'jornada.top.periodo.paradoAbertura': 'Maior tempo parado após abrir no período',
    'jornada.top.periodo.paradoEncerramento': 'Maior tempo parado antes de fechar no período',
    'jornada.top.emptyPeriodo': 'Sem dados no período.',
    'jornada.top.semEncerramentoPeriodo': 'Nenhuma jornada encerrada no período',
    'jornada.statusTempo.emptyPeriodo': 'Nenhum colaborador com etapa registrada no período.',
    'jornada.analise.descargaSuspeitasPeriodo_one': '{{count}} carga com fim de descarga suspeito',
    'jornada.analise.descargaSuspeitasPeriodo_other': '{{count}} cargas com fim de descarga suspeito',
    'jornada.top.ocorrencias_one': '{{count}} ocorrência',
    'jornada.top.ocorrencias_other': '{{count}} ocorrências',
    'jornada.infracao.tipo.interjornada': 'Interjornada',
    'jornada.infracao.tipo.refeicao': 'Refeição',
    'jornada.infracao.tipo.direcao': 'Direção contínua',
    'jornada.infracao.tipo.deslocamento': 'Encerrou longe da abertura',
    'jornada.infracao.tipo.disposicao_hora_extra': 'Disposição com hora extra',
    'jornada.infracao.tipo.trabalho_acima_12_horas': 'Trabalho acima de 12 horas',
    'jornada.infracao.tipo.tpi_hora_extra': 'TPI acima de 1 hora',
    'jornada.infracao.tipo.tpf_hora_extra': 'TPF acima de 1 hora',
    'jornada.infracao.tipo.tpi_tpf_hora_extra': 'TPF e TPI acima de 1 hora',
    'jornada.kpi.infracao.trabalho_acima_12_horasHint': 'Jornada superior a 12 horas com diária TRABALHO no Protheus, em qualquer função. Desde 16/09, só no dia que registrou hora extra',
    'jornada.kpi.infracao.tpi_hora_extraHint': 'só motorista e prancheiro: mais de 1 hora parado logo após abrir a jornada, em jornada que registrou hora extra. No domingo só conta a hora extra acima de 7h20, e no feriado, acima de 8h00. Desde 16/09 conta o tempo que o rastreador do veículo confirma parado, e sem rastreador vale o da ATS, com aviso',
    'jornada.kpi.infracao.tpf_hora_extraHint': 'só motorista e prancheiro: mais de 1 hora parado antes de encerrar a jornada, em jornada que registrou hora extra. No domingo só conta a hora extra acima de 7h20, e no feriado, acima de 8h00. Desde 16/09 conta o tempo que o rastreador do veículo confirma parado, e sem rastreador vale o da ATS, com aviso',
    'jornada.kpi.infracao.tpi_tpf_hora_extraHint': 'só motorista e prancheiro: mais de 1 hora parado logo após abrir e mais de 1 hora antes de encerrar a mesma jornada, que registrou hora extra. Conta uma ocorrência só. Desde 16/09 conta o tempo que o rastreador do veículo confirma parado, e sem rastreador vale o da ATS, com aviso',
    'jornada.infracoes.top.trabalho_acima_12_horas': 'Mais jornadas de trabalho acima de 12 horas',
    'jornada.infracoes.top.tpi_hora_extra': 'Mais tempo parado no início da jornada',
    'jornada.infracoes.top.tpf_hora_extra': 'Mais tempo parado no fim da jornada',
    'jornada.infracoes.top.tpi_tpf_hora_extra': 'Mais tempo parado no início e no fim da jornada',
    'jornada.infracao.tipo.abertura_antecipada': 'Abriu jornada antes do programado',
    'jornada.kpi.infracao.abertura_antecipadaHint': 'só motorista: jornada aberta mais de 1 hora antes do horário programado da primeira carga da escala do dia, com menos de 15 km rodados até o horário programado. Desde 16/09, só em jornada que registrou hora extra',
    'jornada.infracoes.top.abertura_antecipada': 'Mais aberturas antes do programado',
    'jornada.infracoes.colProgramadoPara': 'Programado para',
    'jornada.infracoes.colClienteAlocado': 'Cliente alocado',
    'jornada.infracoes.semEscala': 'Sem escala',
    'jornada.infracoes.maisProgramacoes_one': 'mais {{count}} no dia',
    'jornada.infracoes.maisProgramacoes_other': 'mais {{count}} no dia',
    'jornada.infracoes.abrirPivo': 'Abrir o pivô do contrato {{contrato}} no Google Maps',
    'jornada.infracoes.semPivo': 'O contrato {{contrato}} não tem a coordenada do pivô',
    'jornada.infracoes.semContrato': 'A programação não tem contrato, e por isso não tem pivô',
    'jornada.infracoes.programacaoOrigem.escala': 'Escala da Frente de Trabalho',
    'jornada.infracoes.programacaoOrigem.colheita': 'Programação de colheita',
    'jornada.infracoes.kmAteProgramado': '{{km}} até o horário programado',
    'jornada.infracoes.refeicaoTardia': 'Iniciada com {{tempo}} de jornada',
    'jornada.lista.statusDaPrancha': 'Pela viagem de transporte de máquina',
    'jornada.batidas.title': 'Batidas do dia',
    'jornada.batidas.empty': 'Sem batidas hoje.',
    'jornada.batidas.verNoMapa': 'Posição da batida',
    'jornada.batidas.abrir': 'Batidas do dia',
    'jornada.kpi.abertas': 'Jornada aberta',
    'jornada.kpi.dirigindo': 'Dirigindo',
    'jornada.kpi.parado': 'Parado',
    'jornada.kpi.refeicao': 'Refeição',
    'jornada.kpi.descanso': 'Em descanso',
    'jornada.kpi.he4': 'Jornada de 8h a 12h',
    'jornada.kpi.he4Hint': 'jornada líquida entre 8h e 12h, jornadas abertas hoje',
    'jornada.kpi.heAcima': 'Jornada acima de 12h',
    'jornada.kpi.heAcimaHint': 'jornada líquida passou de 12h, jornadas abertas hoje',
    // Os três totalizadores da régua de hora extra do cliente (25/08/2026). As de
    // 50% e as de 100% saem de DENTRO das trabalhadas: o rodapé de cada card diz
    // isso, para ninguém somar os três e ver a jornada duas vezes.
    'jornada.kpi.trabalhadas': 'Horas trabalhadas',
    'jornada.kpi.trabalhadasHint': 'jornada sem refeição, repouso e descanso, jornadas abertas hoje',
    'jornada.kpi.he50': 'Horas 50%',
    'jornada.kpi.he50Hint': 'hora extra da ATS em dia útil, jornadas abertas hoje',
    'jornada.kpi.he100': 'Horas 100%',
    'jornada.kpi.he100Hint': 'hora extra da ATS em domingo e feriado, jornadas abertas hoje',
    'jornada.he.faixa': 'Hora extra marcada pela ATS',
    'jornada.kpi.heDirecao': 'Extra em direção',
    'jornada.kpi.heDirecaoHint': 'marcação 122 da ATS, jornadas abertas hoje',
    'jornada.kpi.heParado': 'Extra parado',
    'jornada.kpi.heParadoHint': 'marcação 156 da ATS, jornadas abertas hoje',
    'jornada.kpi.heTotal': 'Hora extra',
    'jornada.kpi.heTotalHint': 'direção mais parado, como a ATS marcou',
    'jornada.kpi.jornadasHoje': 'jornadas abertas hoje',
    'jornada.kpi.infracao.interjornada': 'Interjornada abaixo de 11h',
    'jornada.kpi.infracao.interjornadaHint': 'menos de 11h entre o fim da jornada anterior e o início desta',
    'jornada.kpi.infracao.refeicao': 'Refeição fora de 1h a 2h',
    'jornada.kpi.infracao.refeicaoHint': 'refeição menor que 1h ou iniciada depois de 6h em jornada acima de 6h, ou maior que 2h em qualquer jornada',
    'jornada.kpi.infracao.direcao': 'Direção acima de 5h30',
    'jornada.kpi.infracao.direcaoHint': 'direção contínua acima de 5h30. Só pausa de 30min ou mais reinicia a contagem',
    'jornada.kpi.infracao.deslocamento': 'Operador encerrou a mais de 10 km',
    'jornada.kpi.infracao.deslocamentoHint': 'só operador: mais de 10 km em linha reta entre a abertura e o encerramento da jornada. Desde 16/09, só em jornada que registrou hora extra. Coordenada ausente não gera',
    'jornada.infracoes.semRastreador': 'Sem garantia do rastreador',
    'jornada.infracoes.semRastreadorDica': 'O rastreador não conferiu este tempo parado, por falta de veículo identificado na jornada ou de posição perto da abertura ou do encerramento. Vale o tempo da ATS.',
    'jornada.kpi.infracao.disposicao_hora_extra': 'Disposição acima do teto do dia',
    'jornada.kpi.infracao.disposicao_hora_extraHint': 'Disposição no Protheus com jornada acima de 12h para Manobra. Demais funções: 8h de segunda a sexta, 4h no sábado e 7h20 no domingo',
    'jornada.kpi.infracao.clique': 'clique para filtrar a lista e os rankings',
    'jornada.filtro.base': 'Base',
    'jornada.filtro.motorista': 'Motorista',
    'jornada.filtro.veiculo': 'Veículo',
    'jornada.filtro.situacao': 'Situação',
    'jornada.filtro.alerta': 'Alerta',
    'jornada.filtro.todas': 'Todas',
    'jornada.filtro.todos': 'Todos',
    'jornada.filtro.semBase': 'Sem base',
    'jornada.filtro.statusJornada': 'Status da jornada',
    'jornada.filtro.funcao': 'Função',
    'jornada.filtro.cliente': 'Cliente',
    'jornada.filtro.dupla': 'Dupla',
    'jornada.filtro.buscarCliente': 'Buscar cliente',
    'jornada.filtro.buscarDupla': 'Buscar dupla',
    'jornada.statusJornada.aberta': 'Aberta',
    'jornada.statusJornada.fechada': 'Fechada',
    'jornada.lista.title': 'Motoristas do dia',
    'jornada.lista.hint': 'clique na linha para ver as batidas',
    'jornada.lista.empty': 'Nenhum motorista com os filtros atuais.',
    'jornada.lista.colBase': 'Base',
    'jornada.lista.colNome': 'Nome',
    'jornada.lista.colFuncao': 'Função',
    'jornada.lista.colVeiculo': 'Veículo',
    'jornada.lista.colSituacao': 'Situação',
    'jornada.lista.colTempoSituacao': 'Tempo na situação',
    'jornada.lista.colStatusJornada': 'Status da jornada',
    'jornada.lista.colInicio': 'Início',
    'jornada.lista.colFim': 'Fim',
    'jornada.lista.colLiquida': 'Jornada',
    'jornada.lista.colHe50': 'Extra 50%',
    'jornada.lista.colHe100': 'Extra 100%',
    'jornada.lista.colHeDirecao': 'Extra direção',
    'jornada.lista.colHeParado': 'Extra parado',
    'jornada.lista.colHeTotal': 'Extra total',
    'jornada.lista.colDistancia': 'Distância',
    'jornada.lista.colLocal': 'Último local',
    'jornada.lista.colCliente': 'Cliente',
    'jornada.lista.colDupla': 'Dupla',
    'jornada.lista.colAlerta': 'Alerta',
    'jornada.lista.colStatus': 'Status',
    'jornada.statusTempo.title': 'Tempo por status operacional',
    'jornada.statusTempo.colNome': 'Colaborador',
    'jornada.statusTempo.colTotal': 'Total',
    'jornada.statusTempo.empty': 'Nenhum colaborador com etapa registrada hoje.',
    'jornada.statusTempo.presumido_one': '{{count}} sem evento no dia',
    'jornada.statusTempo.presumido_other': '{{count}} sem evento no dia',
    'jornada.statusTempo.presumidoDica': 'Sem mudança de status registrada hoje, a linha do tempo assume o status atual valendo o dia inteiro. É número presumido, não medido.',
    'jornada.distancia.parcial': 'Cobertura parcial do rastreador. O número descreve só o trecho medido.',
    'jornada.distancia.indisponivel': 'Sem cobertura do rastreador para este período.',
    'jornada.alerta.ate4': 'Jornada de 8h a 12h',
    'jornada.alerta.acima4': 'Jornada acima de 12h',
    'jornada.alerta.ausenciaRefeicao': 'Ausência Refeição',
    'jornada.tela.dia': 'Análise do dia',
    'jornada.tela.historico': 'Histórico',
    'jornada.tela.infracoes': 'Relatório de Infrações',
    'jornada.infracoes.title': 'Infrações de jornada',
    'jornada.infracoes.hint': 'uma linha por ocorrência. Clique para ver as batidas da jornada',
    'jornada.infracoes.empty': 'Nenhuma ocorrência com os filtros atuais.',
    'jornada.infracoes.count_one': '{{count, number}} ocorrência',
    'jornada.infracoes.count_other': '{{count, number}} ocorrências',
    'jornada.infracoes.colInfracao': 'Infração',
    'jornada.infracoes.colTratativa': 'Tratativa',
    'jornada.infracoes.tratar': 'Tratar',
    'jornada.infracoes.editar': 'Editar',
    'jornada.infracoes.tratar.titulo': 'Tratar infração',
    'jornada.infracoes.tratar.ok.justificado': 'Infração justificada.',
    'jornada.infracoes.tratar.ok.advertencia': 'Infração classificada como Gestão. Ela aparece no Relatório de Ocorrências do módulo de Gestões.',
    'jornada.infracoes.tratativa.pendente': 'Pendente',
    'jornada.infracoes.tratativa.justificado': 'Justificada',
    'jornada.infracoes.tratativa.advertencia': 'Gestão',
    'jornada.infracoes.tratadoPor': '{{quem}}, {{quando}}',
    'jornada.infracoes.filtroTratativa': 'Tratativa',
    'jornada.infracoes.kpiTotal': 'Ocorrências',
    'jornada.infracoes.kpiTotalHint': 'no período, somando os três tipos',
    'jornada.infracoes.kpiColaboradores': 'Colaboradores',
    'jornada.infracoes.kpiColaboradoresHint': 'com ao menos uma ocorrência no período',
    'jornada.infracoes.topTotal': 'Mais infrações no período',
    'jornada.infracoes.top.interjornada': 'Mais interjornadas curtas',
    'jornada.infracoes.top.refeicao': 'Mais refeições fora do intervalo',
    'jornada.infracoes.top.direcao': 'Mais direção contínua acima de 5h30',
    'jornada.infracoes.top.deslocamento': 'Mais encerramentos longe da abertura',
    'jornada.infracoes.top.disposicao_hora_extra': 'Mais disposições com hora extra',
    'jornada.historico.title': 'Histórico de jornada',
    'jornada.historico.hint': 'clique na linha para ver as batidas do dia',
    'jornada.export.dica': 'Baixa o período filtrado inteiro, não só esta página',
    'jornada.export.vazio': 'Nada para baixar com os filtros atuais.',
    'jornada.historico.empty': 'Nenhum dia com os filtros atuais.',
    'jornada.historico.count_one': '{{count, number}} registro',
    'jornada.historico.count_other': '{{count, number}} registros',
    'jornada.historico.de': 'De',
    'jornada.historico.ate': 'Até',
    'jornada.historico.colData': 'Data',
    'jornada.historico.colDiaria': 'Diária',
    'jornada.historico.colDiaSemana': 'Dia',
    'jornada.historico.colTipoDiaria': 'Tipo',
    'jornada.historico.colResponsavel': 'Responsável',
    'jornada.infracoes.colTempoJornada': 'Tempo de jornada',
    'jornada.infracoes.colRefeicao': 'Refeição',
    'jornada.infracoes.colHoraExtra': 'Hora extra',
    'jornada.historico.semBatida': 'Sem batida na origem',
    'jornada.historico.naoEncerrada': 'Não encerrada',
    'jornada.historico.colNome': 'Nome',
    'jornada.historico.colMatricula': 'Matrícula',
    'jornada.historico.colFuncao': 'Função',
    'jornada.historico.colBase': 'Base',
    'jornada.historico.colDupla': 'Dupla',
    'jornada.historico.colCliente': 'Cliente',
    'jornada.historico.colVeiculo': 'Veículo',
    'jornada.historico.colInicio': 'Início',
    'jornada.historico.colLocalInicio': 'Local de início',
    'jornada.historico.colFim': 'Fim',
    'jornada.historico.colLocalFim': 'Local de fim',
    'jornada.historico.abrirNoMaps': 'Abrir no Google Maps',
    'jornada.historico.semReferencia': 'Sem referência',
    'jornada.historico.semCoordenada': 'A ATS não carimbou coordenada nesta batida',
    'jornada.historico.colJornada': 'Jornada',
    'jornada.historico.colDirecao': 'Direção',
    'jornada.historico.colHe50': 'Extra 50%',
    'jornada.historico.colHe100': 'Extra 100%',
    'jornada.historico.colHeDirecao': 'Extra direção',
    'jornada.historico.colHeParado': 'Extra parado',
    'jornada.historico.colHeTotal': 'Extra total',
    'jornada.historico.colDistancia': 'Distância',
    'jornada.historico.colTpi': 'TPI',
    'jornada.historico.colTpf': 'TPF',
    'jornada.historico.colParado': 'Parado total',
    'jornada.historico.colAlerta': 'Alerta',
    'jornada.historico.kpiTrabalho': 'Trabalho',
    'jornada.historico.kpiFolga': 'Folga',
    'jornada.historico.kpiDisposicao': 'À disposição',
    'jornada.historico.kpiOutros': 'Outros',
    'jornada.historico.kpiDiasHint': 'dias no período',
    'jornada.historico.kpiOutrosHint': 'feriado, DSR e demais',
    'jornada.historico.kpiParado': 'Tempo parado',
    'jornada.historico.kpiParadoHint': '{{tpi}}% no início da jornada, {{tpf}}% no fim',
    'jornada.historico.kpiTrabalhadasHint': 'jornada sem refeição, repouso e descanso, no período',
    'jornada.historico.kpiHe50Hint': 'hora extra da ATS em dia útil, no período',
    'jornada.historico.kpiHe100Hint': 'hora extra da ATS em domingo e feriado, no período',
    'jornada.historico.kpiHeDirecaoHint': 'marcação 122 da ATS, no período',
    'jornada.historico.kpiHeParadoHint': 'marcação 156 da ATS, no período',
    'jornada.historico.kpiHeTotalHint': 'totalizador da ATS, com o DSR inteiro, no período',
    'jornada.historico.kpiParadoVazio': 'sem tempo parado no período',
    'jornada.analise.grupoParado': 'Tempo parado',
    'jornada.analise.dicaParado': 'Sai das marcações da ATS. Conta o tempo parado inteiro, em qualquer faixa; a hora extra aparece à parte, como contexto.',
    'jornada.analise.motorista': 'motorista',
    'jornada.analise.motoristas': 'motoristas',
    'jornada.analise.aberturaTitulo': 'Tempo parado após abrir a jornada',
    'jornada.analise.aberturaApoio': '{{quem}}, sendo {{he}} em hora extra',
    'jornada.analise.encerramentoTitulo': 'Tempo parado antes de finalizar a jornada',
    'jornada.analise.encerramentoApoio': '{{quem}}, sendo {{he}} em hora extra',
    'jornada.analise.encerramentoParcial': 'enche ao longo do dia: jornada aberta ainda não tem encerramento',
    'jornada.analise.descargaTitulo': 'Jornada dentro do Descarregando',
    'jornada.analise.descargaApoio': '{{quem}}, sobre {{janela}} de permanência no destino',
    'jornada.analise.descargaSuspeitas': '{{n}} carga presa há mais de 24h',
  },
  en: {
    'jornada.dashboard.title': 'Journey Panel',
    'jornada.dashboard.eyebrow': 'Operations',
    'jornada.dashboard.loadError': 'Could not load journey data.',
    'jornada.dashboard.retry': 'Try again',
    'jornada.dashboard.kpiEmJornada': 'On journey',
    'jornada.dashboard.kpiEmJornadaHint': 'of the fleet',
    'jornada.dashboard.kpiDirigindo': 'Driving',
    'jornada.dashboard.kpiDescanso': 'Resting',
    'jornada.dashboard.kpiRiscoDsr': 'Weekly-rest risk',
    'jornada.dashboard.kpiRiscoDsrHint': '6+ days without a day off',
    'jornada.dashboard.hintNow': 'now',
    'jornada.dashboard.somenteHoje': 'Today, live. Closed days live in History',
    'jornada.base.total_one': '{{count}} worker in today\u2019s base',
    'jornada.base.total_other': '{{count}} workers in today\u2019s base',
    'jornada.base.recorte': '{{n}} of {{total}}',
    'jornada.base.comMarcacao': 'with punches recorded today',
    'jornada.base.comConjunto': 'with an active truck set',
    'jornada.base.dica': 'All three blocks share one base: every active driver and operator on file. What changes is the slice each one takes.',
    'jornada.analise.indisponivel': 'Unavailable until closing',
    'jornada.analise.encerramentoIndisponivel': 'no journey closed yet. The fleet closes in batch the next day, so there is nothing to measure right now',
    'jornada.top.semEncerramento': 'No journey closed yet today',
    'jornada.dashboard.kpiDirecaoHoje': 'Driving hours',
    'jornada.dashboard.kpiHoraExtra': 'Overtime hours',
    'jornada.dashboard.kpiHorasHint': 'fleet total for today',
    'jornada.dashboard.statusTitle': 'Fleet on journey',
    'jornada.dashboard.statusCenter': 'on journey',
    'jornada.dashboard.statusEmpty': 'Nobody on journey right now.',
    'jornada.dashboard.atencaoTitle': 'Attention',
    'jornada.dashboard.dsrTitle': 'Weekly rest',
    'jornada.dashboard.dsrDias_one': '{{count}} day',
    'jornada.dashboard.dsrDias_other': '{{count}} days',
    'jornada.dashboard.dsrEmpty': 'Nobody at risk.',
    'jornada.dashboard.dispTitle': 'Becoming available',
    'jornada.dashboard.dispEmpty': 'No upcoming forecasts.',
    'jornada.analytics.indisponivel': 'Today’s journey events are unavailable right now. Charts return on the next cycle.',
    'jornada.timeline.title': 'Fleet timeline',
    'jornada.timeline.count_one': '{{count}} driver',
    'jornada.timeline.count_other': '{{count}} drivers',
    'jornada.timeline.empty': 'No events today.',
    'jornada.timeline.periodo': '{{ini}} to {{fim}}',
    'jornada.timeline.agora': 'now',
    'jornada.tipo.direcao': 'Driving',
    'jornada.tipo.parado': 'Stopped',
    'jornada.tipo.refeicao': 'Meal',
    'jornada.tipo.repouso': 'Rest break',
    'jornada.tipo.espera': 'Waiting',
    'jornada.tipo.descanso': 'Daily rest',
    'jornada.tipo.outro': 'Other',
    'jornada.tipo.he': 'Overtime',
    'jornada.composicao.title': 'Fleet through the day',
    'jornada.composicao.hint': 'Drivers in each state, minute by minute',
    'jornada.top.direcao': 'Most driving today',
    'jornada.top.horaExtra': 'Most overtime today',
    'jornada.top.horaExtraDirecao': 'Most overtime driving',
    'jornada.top.horaExtraParado': 'Most overtime idle',
    'jornada.top.parado': 'Most time stopped today',
    'jornada.top.paradoAbertura': 'Longest stop after opening',
    'jornada.top.paradoEncerramento': 'Longest stop before closing',
    'jornada.top.empty': 'No data today.',
    'jornada.top.infracao.interjornada': 'Shortest rest between shifts',
    'jornada.top.infracao.refeicao': 'Meal furthest outside the window',
    'jornada.top.infracao.direcao': 'Longest continuous driving',
    'jornada.top.infracao.deslocamento': 'Largest distance between opening and closing',
    'jornada.top.semInfracao': 'No occurrences today',
    'jornada.top.periodo.direcao': 'Most driving in the period',
    'jornada.top.periodo.horaExtra': 'Most overtime in the period',
    'jornada.top.periodo.horaExtraDirecao': 'Most overtime driving in the period',
    'jornada.top.periodo.horaExtraParado': 'Most overtime idle in the period',
    'jornada.top.periodo.parado': 'Most time stopped in the period',
    'jornada.top.periodo.paradoAbertura': 'Longest stop after opening in the period',
    'jornada.top.periodo.paradoEncerramento': 'Longest stop before closing in the period',
    'jornada.top.emptyPeriodo': 'No data in the period.',
    'jornada.top.semEncerramentoPeriodo': 'No shift closed in the period',
    'jornada.statusTempo.emptyPeriodo': 'No employee with a recorded stage in the period.',
    'jornada.analise.descargaSuspeitasPeriodo_one': '{{count}} load with a suspicious unloading end',
    'jornada.analise.descargaSuspeitasPeriodo_other': '{{count}} loads with a suspicious unloading end',
    'jornada.top.ocorrencias_one': '{{count}} occurrence',
    'jornada.top.ocorrencias_other': '{{count}} occurrences',
    'jornada.infracao.tipo.interjornada': 'Rest between shifts',
    'jornada.infracao.tipo.refeicao': 'Meal',
    'jornada.infracao.tipo.direcao': 'Continuous driving',
    'jornada.infracao.tipo.deslocamento': 'Closed far from opening',
    'jornada.infracao.tipo.disposicao_hora_extra': 'Availability with overtime',
    'jornada.infracao.tipo.trabalho_acima_12_horas': 'Work over 12 hours',
    'jornada.infracao.tipo.tpi_hora_extra': 'Idle start over 1 hour',
    'jornada.infracao.tipo.tpf_hora_extra': 'Idle end over 1 hour',
    'jornada.infracao.tipo.tpi_tpf_hora_extra': 'Idle end and start over 1 hour',
    'jornada.kpi.infracao.trabalho_acima_12_horasHint': 'Workday over 12 hours with a WORK allowance in Protheus, for every role. Since September 16, only on days that logged overtime',
    'jornada.kpi.infracao.tpi_hora_extraHint': 'drivers and lowboy drivers only: over 1 hour idle right after opening the shift, on a shift that logged overtime. On Sundays only overtime above 7h20 counts, and on holidays above 8h00. Since September 16 the time the vehicle tracker confirms as stopped counts, and without the tracker the ATS time applies, with a warning',
    'jornada.kpi.infracao.tpf_hora_extraHint': 'drivers and lowboy drivers only: over 1 hour idle before closing the shift, on a shift that logged overtime. On Sundays only overtime above 7h20 counts, and on holidays above 8h00. Since September 16 the time the vehicle tracker confirms as stopped counts, and without the tracker the ATS time applies, with a warning',
    'jornada.kpi.infracao.tpi_tpf_hora_extraHint': 'drivers and lowboy drivers only: over 1 hour idle right after opening and over 1 hour before closing the same shift, which logged overtime. Counts as one occurrence. Since September 16 the time the vehicle tracker confirms as stopped counts, and without the tracker the ATS time applies, with a warning',
    'jornada.infracoes.top.trabalho_acima_12_horas': 'Most workdays over 12 hours',
    'jornada.infracoes.top.tpi_hora_extra': 'Most idle time at the start of the shift',
    'jornada.infracoes.top.tpf_hora_extra': 'Most idle time at the end of the shift',
    'jornada.infracoes.top.tpi_tpf_hora_extra': 'Most idle time at the start and end of the shift',
    'jornada.infracao.tipo.abertura_antecipada': 'Opened the shift before schedule',
    'jornada.kpi.infracao.abertura_antecipadaHint': 'drivers only: shift opened more than 1 hour before the scheduled time of the first load of the day, with less than 15 km driven until the scheduled time. Since September 16, only on shifts that logged overtime',
    'jornada.infracoes.top.abertura_antecipada': 'Most shifts opened before schedule',
    'jornada.infracoes.colProgramadoPara': 'Scheduled for',
    'jornada.infracoes.colClienteAlocado': 'Assigned customer',
    'jornada.infracoes.semEscala': 'No schedule',
    'jornada.infracoes.maisProgramacoes_one': '{{count}} more that day',
    'jornada.infracoes.maisProgramacoes_other': '{{count}} more that day',
    'jornada.infracoes.abrirPivo': 'Open the pivot of contract {{contrato}} in Google Maps',
    'jornada.infracoes.semPivo': 'Contract {{contrato}} has no pivot coordinates',
    'jornada.infracoes.semContrato': 'The schedule has no contract, so it has no pivot',
    'jornada.infracoes.programacaoOrigem.escala': 'Work Front schedule',
    'jornada.infracoes.programacaoOrigem.colheita': 'Harvest schedule',
    'jornada.infracoes.kmAteProgramado': '{{km}} until the scheduled time',
    'jornada.infracoes.refeicaoTardia': 'Started {{tempo}} into the shift',
    'jornada.lista.statusDaPrancha': 'From the machine transport trip',
    'jornada.batidas.title': 'Today’s punches',
    'jornada.batidas.empty': 'No punches today.',
    'jornada.batidas.verNoMapa': 'Punch position',
    'jornada.batidas.abrir': 'Today’s punches',
    'jornada.kpi.abertas': 'Open journeys',
    'jornada.kpi.dirigindo': 'Driving',
    'jornada.kpi.parado': 'Stopped',
    'jornada.kpi.refeicao': 'Meal',
    'jornada.kpi.descanso': 'Resting',
    'jornada.kpi.he4': 'Workday 8h to 12h',
    'jornada.kpi.he4Hint': 'net journey between 8h and 12h, shifts opened today',
    'jornada.kpi.heAcima': 'Workday over 12h',
    'jornada.kpi.heAcimaHint': 'net journey past 12h, shifts opened today',
    'jornada.kpi.trabalhadas': 'Hours worked',
    'jornada.kpi.trabalhadasHint': 'journey without meal, rest and daily rest, shifts opened today',
    'jornada.kpi.he50': 'Overtime 50%',
    'jornada.kpi.he50Hint': 'ATS overtime on a regular day, shifts opened today',
    'jornada.kpi.he100': 'Overtime 100%',
    'jornada.kpi.he100Hint': 'ATS overtime on Sunday and holiday, shifts opened today',
    'jornada.he.faixa': 'Overtime recorded by ATS',
    'jornada.kpi.heDirecao': 'Overtime driving',
    'jornada.kpi.heDirecaoHint': 'ATS record 122, shifts opened today',
    'jornada.kpi.heParado': 'Overtime idle',
    'jornada.kpi.heParadoHint': 'ATS record 156, shifts opened today',
    'jornada.kpi.heTotal': 'Overtime',
    'jornada.kpi.heTotalHint': 'driving plus idle, as ATS recorded it',
    'jornada.kpi.jornadasHoje': 'shifts opened today',
    'jornada.kpi.infracao.interjornada': 'Rest under 11h',
    'jornada.kpi.infracao.interjornadaHint': 'less than 11h between the end of the previous shift and the start of this one',
    'jornada.kpi.infracao.refeicao': 'Meal outside 1h to 2h',
    'jornada.kpi.infracao.refeicaoHint': 'meal under 1h or started after 6h in a shift over 6h, or over 2h in any shift',
    'jornada.kpi.infracao.direcao': 'Driving over 5h30',
    'jornada.kpi.infracao.direcaoHint': 'continuous driving over 5h30. Only a pause of 30min or more restarts the count',
    'jornada.kpi.infracao.deslocamento': 'Operator closed over 10 km away',
    'jornada.kpi.infracao.deslocamentoHint': 'operators only: more than 10 km in a straight line between opening and closing the shift. Since September 16, only on shifts that logged overtime. A missing coordinate never triggers it',
    'jornada.infracoes.semRastreador': 'Not confirmed by the tracker',
    'jornada.infracoes.semRastreadorDica': 'The tracker did not check this idle time, because the shift has no identified vehicle or no position near the opening or the closing. The ATS time applies.',
    'jornada.kpi.infracao.disposicao_hora_extra': 'Availability above the day cap',
    'jornada.kpi.infracao.disposicao_hora_extraHint': 'Availability in Protheus over 12h for yard drivers. Other roles: 8h Monday to Friday, 4h Saturday and 7h20 Sunday',
    'jornada.kpi.infracao.clique': 'click to filter the list and the rankings',
    'jornada.filtro.base': 'Base',
    'jornada.filtro.motorista': 'Driver',
    'jornada.filtro.veiculo': 'Vehicle',
    'jornada.filtro.situacao': 'Situation',
    'jornada.filtro.alerta': 'Alert',
    'jornada.filtro.todas': 'All',
    'jornada.filtro.todos': 'All',
    'jornada.filtro.semBase': 'No base',
    'jornada.filtro.statusJornada': 'Journey status',
    'jornada.filtro.funcao': 'Role',
    'jornada.filtro.cliente': 'Customer',
    'jornada.filtro.dupla': 'Pair',
    'jornada.filtro.buscarCliente': 'Search customer',
    'jornada.filtro.buscarDupla': 'Search pair',
    'jornada.statusJornada.aberta': 'Open',
    'jornada.statusJornada.fechada': 'Closed',
    'jornada.lista.title': 'Drivers of the day',
    'jornada.lista.hint': 'click a row to see the punches',
    'jornada.lista.empty': 'No drivers with the current filters.',
    'jornada.lista.colBase': 'Base',
    'jornada.lista.colNome': 'Name',
    'jornada.lista.colFuncao': 'Role',
    'jornada.lista.colVeiculo': 'Vehicle',
    'jornada.lista.colSituacao': 'Situation',
    'jornada.lista.colTempoSituacao': 'Time in situation',
    'jornada.lista.colStatusJornada': 'Journey status',
    'jornada.lista.colInicio': 'Start',
    'jornada.lista.colFim': 'End',
    'jornada.lista.colLiquida': 'Journey',
    'jornada.lista.colHe50': 'Overtime 50%',
    'jornada.lista.colHe100': 'Overtime 100%',
    'jornada.lista.colHeDirecao': 'Overtime driving',
    'jornada.lista.colHeParado': 'Overtime idle',
    'jornada.lista.colHeTotal': 'Overtime total',
    'jornada.lista.colDistancia': 'Distance',
    'jornada.lista.colLocal': 'Last location',
    'jornada.lista.colCliente': 'Customer',
    'jornada.lista.colDupla': 'Pair',
    'jornada.lista.colAlerta': 'Alert',
    'jornada.lista.colStatus': 'Status',
    'jornada.statusTempo.title': 'Time per operational status',
    'jornada.statusTempo.colNome': 'Worker',
    'jornada.statusTempo.colTotal': 'Total',
    'jornada.statusTempo.empty': 'No worker with a recorded stage today.',
    'jornada.statusTempo.presumido_one': '{{count}} with no event today',
    'jornada.statusTempo.presumido_other': '{{count}} with no event today',
    'jornada.statusTempo.presumidoDica': 'With no status change recorded today, the timeline assumes the current status held all day. That number is presumed, not measured.',
    'jornada.distancia.parcial': 'Partial tracker coverage. The number covers only the measured stretch.',
    'jornada.distancia.indisponivel': 'No tracker coverage for this period.',
    'jornada.alerta.ate4': 'Workday 8h to 12h',
    'jornada.alerta.acima4': 'Workday over 12h',
    'jornada.alerta.ausenciaRefeicao': 'Missing meal break',
    'jornada.tela.dia': 'Day analysis',
    'jornada.tela.historico': 'History',
    'jornada.tela.infracoes': 'Violations report',
    'jornada.infracoes.title': 'Shift violations',
    'jornada.infracoes.hint': 'one row per occurrence. Click to see the shift punches',
    'jornada.infracoes.empty': 'No occurrences with the current filters.',
    'jornada.infracoes.count_one': '{{count, number}} occurrence',
    'jornada.infracoes.count_other': '{{count, number}} occurrences',
    'jornada.infracoes.colInfracao': 'Violation',
    'jornada.infracoes.colTratativa': 'Handling',
    'jornada.infracoes.tratar': 'Handle',
    'jornada.infracoes.editar': 'Edit',
    'jornada.infracoes.tratar.titulo': 'Handle violation',
    'jornada.infracoes.tratar.ok.justificado': 'Violation justified.',
    'jornada.infracoes.tratar.ok.advertencia': 'Violation classified as a measure. It shows in the Occurrence report of the Measures module.',
    'jornada.infracoes.tratativa.pendente': 'Pending',
    'jornada.infracoes.tratativa.justificado': 'Justified',
    'jornada.infracoes.tratativa.advertencia': 'Measure',
    'jornada.infracoes.tratadoPor': '{{quem}}, {{quando}}',
    'jornada.infracoes.filtroTratativa': 'Handling',
    'jornada.infracoes.kpiTotal': 'Occurrences',
    'jornada.infracoes.kpiTotalHint': 'in the period, all three types',
    'jornada.infracoes.kpiColaboradores': 'Employees',
    'jornada.infracoes.kpiColaboradoresHint': 'with at least one occurrence in the period',
    'jornada.infracoes.topTotal': 'Most violations in the period',
    'jornada.infracoes.top.interjornada': 'Most short rests between shifts',
    'jornada.infracoes.top.refeicao': 'Most meals outside the window',
    'jornada.infracoes.top.direcao': 'Most continuous driving over 5h30',
    'jornada.infracoes.top.deslocamento': 'Most closings far from opening',
    'jornada.infracoes.top.disposicao_hora_extra': 'Most availability with overtime',
    'jornada.historico.title': 'Journey history',
    'jornada.historico.hint': 'click a row to see that day’s punches',
    'jornada.export.dica': 'Downloads the whole filtered period, not just this page',
    'jornada.export.vazio': 'Nothing to download with the current filters.',
    'jornada.historico.empty': 'No day with the current filters.',
    'jornada.historico.count_one': '{{count, number}} record',
    'jornada.historico.count_other': '{{count, number}} records',
    'jornada.historico.de': 'From',
    'jornada.historico.ate': 'To',
    'jornada.historico.colData': 'Date',
    'jornada.historico.colDiaria': 'Day type',
    'jornada.historico.colDiaSemana': 'Day',
    'jornada.historico.colTipoDiaria': 'Type',
    'jornada.historico.colResponsavel': 'Entered by',
    'jornada.infracoes.colTempoJornada': 'Working time',
    'jornada.infracoes.colRefeicao': 'Meal',
    'jornada.infracoes.colHoraExtra': 'Overtime',
    'jornada.historico.semBatida': 'No punch at the source',
    'jornada.historico.naoEncerrada': 'Not closed',
    'jornada.historico.colNome': 'Name',
    'jornada.historico.colMatricula': 'Payroll ID',
    'jornada.historico.colFuncao': 'Role',
    'jornada.historico.colBase': 'Base',
    'jornada.historico.colDupla': 'Pair',
    'jornada.historico.colCliente': 'Customer',
    'jornada.historico.colVeiculo': 'Vehicle',
    'jornada.historico.colInicio': 'Start',
    'jornada.historico.colLocalInicio': 'Start location',
    'jornada.historico.colFim': 'End',
    'jornada.historico.colLocalFim': 'End place',
    'jornada.historico.abrirNoMaps': 'Open in Google Maps',
    'jornada.historico.semReferencia': 'No reference',
    'jornada.historico.semCoordenada': 'ATS did not stamp coordinates on this punch',
    'jornada.historico.colJornada': 'Journey',
    'jornada.historico.colDirecao': 'Driving',
    'jornada.historico.colHe50': 'Overtime 50%',
    'jornada.historico.colHe100': 'Overtime 100%',
    'jornada.historico.colHeDirecao': 'Overtime driving',
    'jornada.historico.colHeParado': 'Overtime idle',
    'jornada.historico.colHeTotal': 'Overtime total',
    'jornada.historico.colDistancia': 'Distance',
    'jornada.historico.colTpi': 'SToS',
    'jornada.historico.colTpf': 'SToE',
    'jornada.historico.colParado': 'Total stopped',
    'jornada.historico.colAlerta': 'Alert',
    'jornada.historico.kpiTrabalho': 'Working',
    'jornada.historico.kpiFolga': 'Day off',
    'jornada.historico.kpiDisposicao': 'On standby',
    'jornada.historico.kpiOutros': 'Other',
    'jornada.historico.kpiDiasHint': 'days in the period',
    'jornada.historico.kpiOutrosHint': 'holiday, weekly rest and the rest',
    'jornada.historico.kpiParado': 'Stopped time',
    'jornada.historico.kpiParadoHint': '{{tpi}}% at the start of the journey, {{tpf}}% at the end',
    'jornada.historico.kpiTrabalhadasHint': 'journey without meal, rest and daily rest, in the period',
    'jornada.historico.kpiHe50Hint': 'ATS overtime on a regular day, in the period',
    'jornada.historico.kpiHe100Hint': 'ATS overtime on Sunday and holiday, in the period',
    'jornada.historico.kpiHeDirecaoHint': 'ATS record 122, in the period',
    'jornada.historico.kpiHeParadoHint': 'ATS record 156, in the period',
    'jornada.historico.kpiHeTotalHint': 'ATS total, with the whole weekly rest day, in the period',
    'jornada.historico.kpiParadoVazio': 'no stopped time in the period',
    'jornada.analise.grupoParado': 'Stopped time',
    'jornada.analise.dicaParado': 'Comes from the ATS punches. Counts the whole stopped time, in any band; overtime shows separately, as context.',
    'jornada.analise.motorista': 'driver',
    'jornada.analise.motoristas': 'drivers',
    'jornada.analise.aberturaTitulo': 'Time stopped after opening the journey',
    'jornada.analise.aberturaApoio': '{{quem}}, of which {{he}} on overtime',
    'jornada.analise.encerramentoTitulo': 'Time stopped before closing the journey',
    'jornada.analise.encerramentoApoio': '{{quem}}, of which {{he}} on overtime',
    'jornada.analise.encerramentoParcial': 'fills up through the day: an open journey has no closing yet',
    'jornada.analise.descargaTitulo': 'Journey inside Unloading',
    'jornada.analise.descargaApoio': '{{quem}}, over {{janela}} spent at the destination',
    'jornada.analise.descargaSuspeitas': '{{n}} load stuck for over 24h',
  },
  es: {
    'jornada.dashboard.title': 'Panel de Jornada',
    'jornada.dashboard.eyebrow': 'Operación',
    'jornada.dashboard.loadError': 'No se pudo cargar la jornada.',
    'jornada.dashboard.retry': 'Reintentar',
    'jornada.dashboard.kpiEmJornada': 'En jornada',
    'jornada.dashboard.kpiEmJornadaHint': 'de la flota',
    'jornada.dashboard.kpiDirigindo': 'Conduciendo',
    'jornada.dashboard.kpiDescanso': 'En descanso',
    'jornada.dashboard.kpiRiscoDsr': 'Riesgo de DSR',
    'jornada.dashboard.kpiRiscoDsrHint': '6+ días sin franco',
    'jornada.dashboard.hintNow': 'ahora',
    'jornada.dashboard.somenteHoje': 'Hoy, en vivo. El día cerrado está en el Histórico',
    'jornada.base.total_one': '{{count}} colaborador en la base del día',
    'jornada.base.total_other': '{{count}} colaboradores en la base del día',
    'jornada.base.recorte': '{{n}} de {{total}}',
    'jornada.base.comMarcacao': 'con marcación registrada hoy',
    'jornada.base.comConjunto': 'con conjunto activo',
    'jornada.base.dica': 'La base es la misma en los tres bloques: todo conductor y operador activo en el registro. Lo que cambia es el recorte de cada uno.',
    'jornada.analise.indisponivel': 'No disponible hasta cerrar',
    'jornada.analise.encerramentoIndisponivel': 'ninguna jornada cerrada todavía. La flota cierra en lote al día siguiente, así que no hay qué medir ahora',
    'jornada.top.semEncerramento': 'Ninguna jornada cerrada todavía hoy',
    'jornada.dashboard.kpiDirecaoHoje': 'Horas de conducción',
    'jornada.dashboard.kpiHoraExtra': 'Horas extras',
    'jornada.dashboard.kpiHorasHint': 'sumadas hoy, flota entera',
    'jornada.dashboard.statusTitle': 'Flota en jornada',
    'jornada.dashboard.statusCenter': 'en jornada',
    'jornada.dashboard.statusEmpty': 'Nadie en jornada ahora.',
    'jornada.dashboard.atencaoTitle': 'Atención',
    'jornada.dashboard.dsrTitle': 'Descanso semanal',
    'jornada.dashboard.dsrDias_one': '{{count}} día',
    'jornada.dashboard.dsrDias_other': '{{count}} días',
    'jornada.dashboard.dsrEmpty': 'Nadie en riesgo.',
    'jornada.dashboard.dispTitle': 'Quedando disponible',
    'jornada.dashboard.dispEmpty': 'Sin pronósticos próximos.',
    'jornada.analytics.indisponivel': 'Los eventos de hoy no están disponibles ahora. Los gráficos vuelven en el próximo ciclo.',
    'jornada.timeline.title': 'Línea de tiempo de la flota',
    'jornada.timeline.count_one': '{{count}} conductor',
    'jornada.timeline.count_other': '{{count}} conductores',
    'jornada.timeline.empty': 'Sin eventos hoy.',
    'jornada.timeline.periodo': '{{ini}} a {{fim}}',
    'jornada.timeline.agora': 'ahora',
    'jornada.tipo.direcao': 'Conducción',
    'jornada.tipo.parado': 'Detenido',
    'jornada.tipo.refeicao': 'Comida',
    'jornada.tipo.repouso': 'Pausa de descanso',
    'jornada.tipo.espera': 'Espera',
    'jornada.tipo.descanso': 'Descanso diario',
    'jornada.tipo.outro': 'Otro',
    'jornada.tipo.he': 'Hora extra',
    'jornada.composicao.title': 'Flota a lo largo del día',
    'jornada.composicao.hint': 'Conductores en cada estado, minuto a minuto',
    'jornada.top.direcao': 'Quién más condujo hoy',
    'jornada.top.horaExtra': 'Quién más hizo horas extras',
    'jornada.top.horaExtraDirecao': 'Más hora extra conduciendo',
    'jornada.top.horaExtraParado': 'Más hora extra detenido',
    'jornada.top.parado': 'Quién más estuvo detenido',
    'jornada.top.paradoAbertura': 'Mayor tiempo detenido tras abrir',
    'jornada.top.paradoEncerramento': 'Mayor tiempo detenido antes de cerrar',
    'jornada.top.empty': 'Sin datos hoy.',
    'jornada.top.infracao.interjornada': 'Menor descanso entre jornadas',
    'jornada.top.infracao.refeicao': 'Comida más fuera del intervalo',
    'jornada.top.infracao.direcao': 'Mayor conducción continua',
    'jornada.top.infracao.deslocamento': 'Mayor distancia entre apertura y cierre',
    'jornada.top.semInfracao': 'Ninguna ocurrencia hoy',
    'jornada.top.periodo.direcao': 'Quién más condujo en el período',
    'jornada.top.periodo.horaExtra': 'Quién más hizo horas extra en el período',
    'jornada.top.periodo.horaExtraDirecao': 'Más hora extra conduciendo en el período',
    'jornada.top.periodo.horaExtraParado': 'Más hora extra detenido en el período',
    'jornada.top.periodo.parado': 'Quién más estuvo detenido en el período',
    'jornada.top.periodo.paradoAbertura': 'Mayor tiempo detenido tras abrir en el período',
    'jornada.top.periodo.paradoEncerramento': 'Mayor tiempo detenido antes de cerrar en el período',
    'jornada.top.emptyPeriodo': 'Sin datos en el período.',
    'jornada.top.semEncerramentoPeriodo': 'Ninguna jornada cerrada en el período',
    'jornada.statusTempo.emptyPeriodo': 'Ningún colaborador con etapa registrada en el período.',
    'jornada.analise.descargaSuspeitasPeriodo_one': '{{count}} carga con fin de descarga sospechoso',
    'jornada.analise.descargaSuspeitasPeriodo_other': '{{count}} cargas con fin de descarga sospechoso',
    'jornada.top.ocorrencias_one': '{{count}} ocurrencia',
    'jornada.top.ocorrencias_other': '{{count}} ocurrencias',
    'jornada.infracao.tipo.interjornada': 'Descanso entre jornadas',
    'jornada.infracao.tipo.refeicao': 'Comida',
    'jornada.infracao.tipo.direcao': 'Conducción continua',
    'jornada.infracao.tipo.deslocamento': 'Cerró lejos de la apertura',
    'jornada.infracao.tipo.disposicao_hora_extra': 'Disposición con hora extra',
    'jornada.infracao.tipo.trabalho_acima_12_horas': 'Trabajo superior a 12 horas',
    'jornada.infracao.tipo.tpi_hora_extra': 'TPI superior a 1 hora',
    'jornada.infracao.tipo.tpf_hora_extra': 'TPF superior a 1 hora',
    'jornada.infracao.tipo.tpi_tpf_hora_extra': 'TPF y TPI superior a 1 hora',
    'jornada.kpi.infracao.trabalho_acima_12_horasHint': 'Jornada superior a 12 horas con viático TRABAJO en Protheus, para todas las funciones. Desde el 16/09, solo en el día que registró hora extra',
    'jornada.kpi.infracao.tpi_hora_extraHint': 'solo conductor y prancheiro: más de 1 hora parado justo después de abrir la jornada, en jornada que registró hora extra. En domingo solo cuenta la hora extra superior a 7h20, y en feriado, superior a 8h00. Desde el 16/09 cuenta el tiempo que el rastreador del vehículo confirma parado, y sin rastreador vale el de la ATS, con aviso',
    'jornada.kpi.infracao.tpf_hora_extraHint': 'solo conductor y prancheiro: más de 1 hora parado antes de cerrar la jornada, en jornada que registró hora extra. En domingo solo cuenta la hora extra superior a 7h20, y en feriado, superior a 8h00. Desde el 16/09 cuenta el tiempo que el rastreador del vehículo confirma parado, y sin rastreador vale el de la ATS, con aviso',
    'jornada.kpi.infracao.tpi_tpf_hora_extraHint': 'solo conductor y prancheiro: más de 1 hora parado justo después de abrir y más de 1 hora antes de cerrar la misma jornada, que registró hora extra. Cuenta como una sola ocurrencia. Desde el 16/09 cuenta el tiempo que el rastreador del vehículo confirma parado, y sin rastreador vale el de la ATS, con aviso',
    'jornada.infracoes.top.trabalho_acima_12_horas': 'Más jornadas de trabajo superiores a 12 horas',
    'jornada.infracoes.top.tpi_hora_extra': 'Más tiempo parado al inicio de la jornada',
    'jornada.infracoes.top.tpf_hora_extra': 'Más tiempo parado al final de la jornada',
    'jornada.infracoes.top.tpi_tpf_hora_extra': 'Más tiempo parado al inicio y al final de la jornada',
    'jornada.infracao.tipo.abertura_antecipada': 'Abrió la jornada antes de lo programado',
    'jornada.kpi.infracao.abertura_antecipadaHint': 'solo conductor: jornada abierta más de 1 hora antes del horario programado de la primera carga de la escala del día, con menos de 15 km recorridos hasta el horario programado. Desde el 16/09, solo en jornada que registró hora extra',
    'jornada.infracoes.top.abertura_antecipada': 'Más aperturas antes de lo programado',
    'jornada.infracoes.colProgramadoPara': 'Programado para',
    'jornada.infracoes.colClienteAlocado': 'Cliente asignado',
    'jornada.infracoes.semEscala': 'Sin escala',
    'jornada.infracoes.maisProgramacoes_one': '{{count}} más en el día',
    'jornada.infracoes.maisProgramacoes_other': '{{count}} más en el día',
    'jornada.infracoes.abrirPivo': 'Abrir el pivote del contrato {{contrato}} en Google Maps',
    'jornada.infracoes.semPivo': 'El contrato {{contrato}} no tiene la coordenada del pivote',
    'jornada.infracoes.semContrato': 'La programación no tiene contrato, por eso no tiene pivote',
    'jornada.infracoes.programacaoOrigem.escala': 'Escala del Frente de Trabajo',
    'jornada.infracoes.programacaoOrigem.colheita': 'Programación de cosecha',
    'jornada.infracoes.kmAteProgramado': '{{km}} hasta el horario programado',
    'jornada.infracoes.refeicaoTardia': 'Iniciada con {{tempo}} de jornada',
    'jornada.lista.statusDaPrancha': 'Por el viaje de transporte de máquina',
    'jornada.batidas.title': 'Marcaciones del día',
    'jornada.batidas.empty': 'Sin marcaciones hoy.',
    'jornada.batidas.verNoMapa': 'Posición de la marcación',
    'jornada.batidas.abrir': 'Marcaciones del día',
    'jornada.kpi.abertas': 'Jornada abierta',
    'jornada.kpi.dirigindo': 'Conduciendo',
    'jornada.kpi.parado': 'Detenido',
    'jornada.kpi.refeicao': 'Comida',
    'jornada.kpi.descanso': 'En descanso',
    'jornada.kpi.he4': 'Jornada de 8h a 12h',
    'jornada.kpi.he4Hint': 'jornada neta entre 8h y 12h, jornadas abiertas hoy',
    'jornada.kpi.heAcima': 'Jornada superior a 12h',
    'jornada.kpi.heAcimaHint': 'jornada neta superó las 12h, jornadas abiertas hoy',
    'jornada.kpi.trabalhadas': 'Horas trabajadas',
    'jornada.kpi.trabalhadasHint': 'jornada sin comida, reposo ni descanso, jornadas abiertas hoy',
    'jornada.kpi.he50': 'Horas 50%',
    'jornada.kpi.he50Hint': 'hora extra de la ATS en día hábil, jornadas abiertas hoy',
    'jornada.kpi.he100': 'Horas 100%',
    'jornada.kpi.he100Hint': 'hora extra de la ATS en domingo y feriado, jornadas abiertas hoy',
    'jornada.he.faixa': 'Hora extra registrada por la ATS',
    'jornada.kpi.heDirecao': 'Extra conduciendo',
    'jornada.kpi.heDirecaoHint': 'registro 122 de la ATS, jornadas abiertas hoy',
    'jornada.kpi.heParado': 'Extra detenido',
    'jornada.kpi.heParadoHint': 'registro 156 de la ATS, jornadas abiertas hoy',
    'jornada.kpi.heTotal': 'Hora extra',
    'jornada.kpi.heTotalHint': 'conducción más detenido, como la ATS lo registró',
    'jornada.kpi.jornadasHoje': 'jornadas abiertas hoy',
    'jornada.kpi.infracao.interjornada': 'Descanso menor a 11h',
    'jornada.kpi.infracao.interjornadaHint': 'menos de 11h entre el fin de la jornada anterior y el inicio de esta',
    'jornada.kpi.infracao.refeicao': 'Comida fuera de 1h a 2h',
    'jornada.kpi.infracao.refeicaoHint': 'comida menor a 1h o iniciada después de 6h en jornada mayor a 6h, o mayor a 2h en cualquier jornada',
    'jornada.kpi.infracao.direcao': 'Conducción mayor a 5h30',
    'jornada.kpi.infracao.direcaoHint': 'conducción continua mayor a 5h30. Solo una pausa de 30min o más reinicia el conteo',
    'jornada.kpi.infracao.deslocamento': 'Operador cerró a más de 10 km',
    'jornada.kpi.infracao.deslocamentoHint': 'solo operador: más de 10 km en línea recta entre la apertura y el cierre de la jornada. Desde el 16/09, solo en jornada que registró hora extra. Coordenada ausente no genera',
    'jornada.infracoes.semRastreador': 'Sin garantía del rastreador',
    'jornada.infracoes.semRastreadorDica': 'El rastreador no verificó este tiempo detenido, por falta de vehículo identificado en la jornada o de posición cerca de la apertura o del cierre. Vale el tiempo de la ATS.',
    'jornada.kpi.infracao.disposicao_hora_extra': 'Disposición por encima del tope del día',
    'jornada.kpi.infracao.disposicao_hora_extraHint': 'Disposición en Protheus superior a 12h para Manobra. Otras funciones: 8h de lunes a viernes, 4h el sábado y 7h20 el domingo',
    'jornada.kpi.infracao.clique': 'clic para filtrar la lista y los rankings',
    'jornada.filtro.base': 'Base',
    'jornada.filtro.motorista': 'Conductor',
    'jornada.filtro.veiculo': 'Vehículo',
    'jornada.filtro.situacao': 'Situación',
    'jornada.filtro.alerta': 'Alerta',
    'jornada.filtro.todas': 'Todas',
    'jornada.filtro.todos': 'Todos',
    'jornada.filtro.semBase': 'Sin base',
    'jornada.filtro.statusJornada': 'Estado de la jornada',
    'jornada.filtro.funcao': 'Función',
    'jornada.filtro.cliente': 'Cliente',
    'jornada.filtro.dupla': 'Dupla',
    'jornada.filtro.buscarCliente': 'Buscar cliente',
    'jornada.filtro.buscarDupla': 'Buscar dupla',
    'jornada.statusJornada.aberta': 'Abierta',
    'jornada.statusJornada.fechada': 'Cerrada',
    'jornada.lista.title': 'Conductores del día',
    'jornada.lista.hint': 'haz clic en la fila para ver las marcaciones',
    'jornada.lista.empty': 'Ningún conductor con los filtros actuales.',
    'jornada.lista.colBase': 'Base',
    'jornada.lista.colNome': 'Nombre',
    'jornada.lista.colFuncao': 'Función',
    'jornada.lista.colVeiculo': 'Vehículo',
    'jornada.lista.colSituacao': 'Situación',
    'jornada.lista.colTempoSituacao': 'Tiempo en la situación',
    'jornada.lista.colStatusJornada': 'Estado de la jornada',
    'jornada.lista.colInicio': 'Inicio',
    'jornada.lista.colFim': 'Fin',
    'jornada.lista.colLiquida': 'Jornada',
    'jornada.lista.colHe50': 'Extra 50%',
    'jornada.lista.colHe100': 'Extra 100%',
    'jornada.lista.colHeDirecao': 'Extra conducción',
    'jornada.lista.colHeParado': 'Extra detenido',
    'jornada.lista.colHeTotal': 'Extra total',
    'jornada.lista.colDistancia': 'Distancia',
    'jornada.lista.colLocal': 'Último lugar',
    'jornada.lista.colCliente': 'Cliente',
    'jornada.lista.colDupla': 'Dupla',
    'jornada.lista.colAlerta': 'Alerta',
    'jornada.lista.colStatus': 'Estado',
    'jornada.statusTempo.title': 'Tiempo por estado operativo',
    'jornada.statusTempo.colNome': 'Colaborador',
    'jornada.statusTempo.colTotal': 'Total',
    'jornada.statusTempo.empty': 'Ningún colaborador con etapa registrada hoy.',
    'jornada.statusTempo.presumido_one': '{{count}} sin evento en el día',
    'jornada.statusTempo.presumido_other': '{{count}} sin evento en el día',
    'jornada.statusTempo.presumidoDica': 'Sin cambio de estado registrado hoy, la línea de tiempo asume que el estado actual valió todo el día. Es un número presumido, no medido.',
    'jornada.distancia.parcial': 'Cobertura parcial del rastreador. El número describe solo el tramo medido.',
    'jornada.distancia.indisponivel': 'Sin cobertura del rastreador para este período.',
    'jornada.alerta.ate4': 'Jornada de 8h a 12h',
    'jornada.alerta.acima4': 'Jornada superior a 12h',
    'jornada.alerta.ausenciaRefeicao': 'Ausencia de comida',
    'jornada.tela.dia': 'Análisis del día',
    'jornada.tela.historico': 'Historial',
    'jornada.tela.infracoes': 'Informe de infracciones',
    'jornada.infracoes.title': 'Infracciones de jornada',
    'jornada.infracoes.hint': 'una línea por ocurrencia. Clic para ver las marcaciones de la jornada',
    'jornada.infracoes.empty': 'Ninguna ocurrencia con los filtros actuales.',
    'jornada.infracoes.count_one': '{{count, number}} ocurrencia',
    'jornada.infracoes.count_other': '{{count, number}} ocurrencias',
    'jornada.infracoes.colInfracao': 'Infracción',
    'jornada.infracoes.colTratativa': 'Tratamiento',
    'jornada.infracoes.tratar': 'Tratar',
    'jornada.infracoes.editar': 'Editar',
    'jornada.infracoes.tratar.titulo': 'Tratar infracción',
    'jornada.infracoes.tratar.ok.justificado': 'Infracción justificada.',
    'jornada.infracoes.tratar.ok.advertencia': 'Infracción clasificada como gestión. Aparece en el Informe de ocurrencias del módulo de Gestiones.',
    'jornada.infracoes.tratativa.pendente': 'Pendiente',
    'jornada.infracoes.tratativa.justificado': 'Justificada',
    'jornada.infracoes.tratativa.advertencia': 'Gestión',
    'jornada.infracoes.tratadoPor': '{{quem}}, {{quando}}',
    'jornada.infracoes.filtroTratativa': 'Tratamiento',
    'jornada.infracoes.kpiTotal': 'Ocurrencias',
    'jornada.infracoes.kpiTotalHint': 'en el período, sumando los tres tipos',
    'jornada.infracoes.kpiColaboradores': 'Colaboradores',
    'jornada.infracoes.kpiColaboradoresHint': 'con al menos una ocurrencia en el período',
    'jornada.infracoes.topTotal': 'Más infracciones en el período',
    'jornada.infracoes.top.interjornada': 'Más descansos cortos entre jornadas',
    'jornada.infracoes.top.refeicao': 'Más comidas fuera del intervalo',
    'jornada.infracoes.top.direcao': 'Más conducción continua mayor a 5h30',
    'jornada.infracoes.top.deslocamento': 'Más cierres lejos de la apertura',
    'jornada.infracoes.top.disposicao_hora_extra': 'Más disposiciones con hora extra',
    'jornada.historico.title': 'Historial de jornada',
    'jornada.historico.hint': 'haz clic en la fila para ver las marcaciones del día',
    'jornada.export.dica': 'Descarga todo el período filtrado, no solo esta página',
    'jornada.export.vazio': 'Nada para descargar con los filtros actuales.',
    'jornada.historico.empty': 'Ningún día con los filtros actuales.',
    'jornada.historico.count_one': '{{count, number}} registro',
    'jornada.historico.count_other': '{{count, number}} registros',
    'jornada.historico.de': 'Desde',
    'jornada.historico.ate': 'Hasta',
    'jornada.historico.colData': 'Fecha',
    'jornada.historico.colDiaria': 'Tipo de día',
    'jornada.historico.colDiaSemana': 'Día',
    'jornada.historico.colTipoDiaria': 'Tipo',
    'jornada.historico.colResponsavel': 'Responsable',
    'jornada.infracoes.colTempoJornada': 'Tiempo de jornada',
    'jornada.infracoes.colRefeicao': 'Comida',
    'jornada.infracoes.colHoraExtra': 'Hora extra',
    'jornada.historico.semBatida': 'Sin marcación en el origen',
    'jornada.historico.naoEncerrada': 'No cerrada',
    'jornada.historico.colNome': 'Nombre',
    'jornada.historico.colMatricula': 'Matrícula',
    'jornada.historico.colFuncao': 'Función',
    'jornada.historico.colBase': 'Base',
    'jornada.historico.colDupla': 'Dupla',
    'jornada.historico.colCliente': 'Cliente',
    'jornada.historico.colVeiculo': 'Vehículo',
    'jornada.historico.colInicio': 'Inicio',
    'jornada.historico.colLocalInicio': 'Lugar de inicio',
    'jornada.historico.colFim': 'Fin',
    'jornada.historico.colLocalFim': 'Lugar de fin',
    'jornada.historico.abrirNoMaps': 'Abrir en Google Maps',
    'jornada.historico.semReferencia': 'Sin referencia',
    'jornada.historico.semCoordenada': 'La ATS no marcó coordenada en este fichaje',
    'jornada.historico.colJornada': 'Jornada',
    'jornada.historico.colDirecao': 'Conducción',
    'jornada.historico.colHe50': 'Extra 50%',
    'jornada.historico.colHe100': 'Extra 100%',
    'jornada.historico.colHeDirecao': 'Extra conducción',
    'jornada.historico.colHeParado': 'Extra detenido',
    'jornada.historico.colHeTotal': 'Extra total',
    'jornada.historico.colDistancia': 'Distancia',
    'jornada.historico.colTpi': 'TPI',
    'jornada.historico.colTpf': 'TPF',
    'jornada.historico.colParado': 'Detenido total',
    'jornada.historico.colAlerta': 'Alerta',
    'jornada.historico.kpiTrabalho': 'Trabajo',
    'jornada.historico.kpiFolga': 'Franco',
    'jornada.historico.kpiDisposicao': 'A disposición',
    'jornada.historico.kpiOutros': 'Otros',
    'jornada.historico.kpiDiasHint': 'días en el período',
    'jornada.historico.kpiOutrosHint': 'feriado, DSR y demás',
    'jornada.historico.kpiParado': 'Tiempo detenido',
    'jornada.historico.kpiParadoHint': '{{tpi}}% al inicio de la jornada, {{tpf}}% al final',
    'jornada.historico.kpiTrabalhadasHint': 'jornada sin comida, reposo ni descanso, en el período',
    'jornada.historico.kpiHe50Hint': 'hora extra de la ATS en día hábil, en el período',
    'jornada.historico.kpiHe100Hint': 'hora extra de la ATS en domingo y feriado, en el período',
    'jornada.historico.kpiHeDirecaoHint': 'registro 122 de la ATS, en el período',
    'jornada.historico.kpiHeParadoHint': 'registro 156 de la ATS, en el período',
    'jornada.historico.kpiHeTotalHint': 'totalizador de la ATS, con el descanso semanal entero, en el período',
    'jornada.historico.kpiParadoVazio': 'sin tiempo detenido en el período',
    'jornada.analise.grupoParado': 'Tiempo detenido',
    'jornada.analise.dicaParado': 'Sale de las marcaciones de la ATS. Cuenta todo el tiempo detenido, en cualquier franja; la hora extra aparece aparte, como contexto.',
    'jornada.analise.motorista': 'conductor',
    'jornada.analise.motoristas': 'conductores',
    'jornada.analise.aberturaTitulo': 'Tiempo detenido tras abrir la jornada',
    'jornada.analise.aberturaApoio': '{{quem}}, de los cuales {{he}} en hora extra',
    'jornada.analise.encerramentoTitulo': 'Tiempo detenido antes de finalizar la jornada',
    'jornada.analise.encerramentoApoio': '{{quem}}, de los cuales {{he}} en hora extra',
    'jornada.analise.encerramentoParcial': 'se llena a lo largo del día: la jornada abierta aún no tiene cierre',
    'jornada.analise.descargaTitulo': 'Jornada dentro de Descargando',
    'jornada.analise.descargaApoio': '{{quem}}, sobre {{janela}} de permanencia en el destino',
    'jornada.analise.descargaSuspeitas': '{{n}} carga atascada hace más de 24h',
  },
}
